// PrivacyPolicy.js
import React, { useState, useEffect, useRef } from 'react';
import './Pages/PagesCss/PrivacyPolicy.css';
import { useNavigate } from 'react-router-dom';

// ─── Icons ────────────────────────────────────────────────────────────────────
const Icons = {
  Shield:   (p) => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" {...p}><path d="M12 3L4 7V12C4 16.42 7.58 21 12 21C16.42 21 20 16.42 20 12V7L12 3Z" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round"/><path d="M9 12L11 14L15 10" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/></svg>,
  Eye:      (p) => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" {...p}><ellipse cx="12" cy="12" rx="9" ry="5" stroke="currentColor" strokeWidth="1.8"/><circle cx="12" cy="12" r="2.5" stroke="currentColor" strokeWidth="1.8"/></svg>,
  Lock:     (p) => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" {...p}><rect x="5" y="11" width="14" height="10" rx="2" stroke="currentColor" strokeWidth="1.8"/><path d="M8 11V8C8 5.79 9.79 4 12 4C14.21 4 16 5.79 16 8V11" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/><circle cx="12" cy="16" r="1.5" fill="currentColor"/></svg>,
  Trash:    (p) => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" {...p}><path d="M3 6H21M8 6V4H16V6M19 6L18 20H6L5 6" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/></svg>,
  Users:    (p) => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" {...p}><circle cx="9" cy="7" r="3" stroke="currentColor" strokeWidth="1.8"/><path d="M3 20C3 17.24 5.69 15 9 15C12.31 15 15 17.24 15 20" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/><path d="M16 11C17.66 11 19 9.66 19 8C19 6.34 17.66 5 16 5" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/><path d="M21 20C21 17.79 19.21 16 17 16" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/></svg>,
  Cookie:   (p) => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" {...p}><circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1.8"/><circle cx="9" cy="10" r="1" fill="currentColor"/><circle cx="14" cy="8" r="1" fill="currentColor"/><circle cx="15" cy="14" r="1" fill="currentColor"/><circle cx="10" cy="15" r="1" fill="currentColor"/></svg>,
  Mail:     (p) => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" {...p}><rect x="2" y="4" width="20" height="16" rx="2" stroke="currentColor" strokeWidth="1.8"/><path d="M2 8L12 14L22 8" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/></svg>,
  Dollar:   (p) => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" {...p}><circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1.8"/><path d="M12 7V17M9.5 9.5C9.5 8.4 10.62 8 12 8C13.38 8 14.5 8.67 14.5 9.75C14.5 10.83 13.5 11.25 12 11.5C10.5 11.75 9.5 12.28 9.5 13.5C9.5 14.6 10.62 15.5 12 15.5C13.38 15.5 14.5 15.1 14.5 14" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/></svg>,
  Globe:    (p) => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" {...p}><circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1.8"/><path d="M12 3C12 3 8 7 8 12C8 17 12 21 12 21M12 3C12 3 16 7 16 12C16 17 12 21 12 21M3 12H21" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/></svg>,
  Child:    (p) => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" {...p}><circle cx="12" cy="6" r="3" stroke="currentColor" strokeWidth="1.8"/><path d="M6 21V18C6 15.79 7.79 14 10 14H14C16.21 14 18 15.79 18 18V21" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/><path d="M9 11L12 14L15 11" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/></svg>,
  Update:   (p) => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" {...p}><path d="M4 12C4 7.58 7.58 4 12 4C14.67 4 17.04 5.27 18.54 7.25" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/><path d="M20 12C20 16.42 16.42 20 12 20C9.33 20 6.96 18.73 5.46 16.75" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/><path d="M16 7L18.54 7.25L20 5" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/><path d="M8 17L5.46 16.75L4 19" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/></svg>,
  ChevronRight: (p) => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" {...p}><path d="M9 5L16 12L9 19" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>,
  ArrowUp:  (p) => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" {...p}><path d="M12 19V5M5 12L12 5L19 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>,
  Check:    (p) => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" {...p}><path d="M5 12L10 17L19 7" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"/></svg>,
};

// ─── Policy sections data ─────────────────────────────────────────────────────
const SECTIONS = [
  {
    id: 'overview',
    icon: Icons.Shield,
    title: 'Privacy at a Glance',
    color: '#10B981',
    summary: true, // renders as highlight cards instead of prose
    cards: [
      { icon: Icons.Trash,  color: '#10B981', title: 'Files deleted in 1 hour',    body: 'Every file you upload is permanently and automatically deleted from our servers within 1 hour of processing. No exceptions.' },
      { icon: Icons.Eye,    color: '#3B82F6', title: 'We never read your files',    body: 'Your documents are processed by automated systems only. No human at QuickPDFs or D-Tech Studios ever views your content.' },
      { icon: Icons.Dollar, color: '#F59E0B', title: 'No selling your data',        body: 'We do not sell, rent, or trade your personal information or file contents to any third party, ever.' },
      { icon: Icons.Cookie, color: '#8B5CF6', title: 'Minimal cookies only',        body: 'We use only essential and analytics cookies. No advertising trackers, no cross-site tracking, no fingerprinting.' },
    ],
  },
  {
    id: 'information',
    icon: Icons.Users,
    title: '1. Information We Collect',
    color: '#3B82F6',
    content: [
      {
        subtitle: 'Information you provide directly',
        body: `When you create an account or subscribe to a paid plan, we collect the information you provide: your name, email address, and payment information. Payment details are processed securely by Stripe we never store your full card number on our servers.

If you contact us through our support form or email, we collect the contents of that message along with your name and email address so we can respond to you.`,
      },
      {
        subtitle: 'Files you upload',
        body: `When you use any QuickPDFs tool, you upload files to our servers for processing. These files are used solely to perform the requested operation (e.g. merging, compressing, converting). Files are stored temporarily in encrypted memory and are permanently deleted within 1 hour of processing, regardless of whether you download the output.

We do not analyse, index, train machine learning models on, or otherwise use the contents of your files for any purpose other than performing the tool operation you requested.`,
      },
      {
        subtitle: 'Automatically collected information',
        body: `Like most websites, we automatically collect certain technical information when you visit QuickPDFs:

• IP address (anonymised after 24 hours)
• Browser type and version
• Operating system
• Pages visited and time spent
• Referring URL
• Country/region (derived from IP, not stored individually)

This information is used solely for security monitoring, debugging, and understanding aggregate usage patterns. It is never linked to your personal identity unless required for fraud prevention.`,
      },
      {
        subtitle: 'Free plan vs paid plans',
        body: `Free plan users: We collect only the technical information above. No account creation is required, and we do not associate your uploads with any identity.

Pro and Business subscribers: We additionally collect the account information you provide at sign-up, your billing history, and your file processing history for the last 30–90 days (depending on your plan) to power features like File History in your dashboard.`,
      },
    ],
  },
  {
    id: 'howweuse',
    icon: Icons.Eye,
    title: '2. How We Use Your Information',
    color: '#8B5CF6',
    content: [
      {
        subtitle: 'To provide the service',
        body: `The primary use of all data we collect is to operate QuickPDFs processing your files, managing your account, sending billing receipts, and providing customer support.`,
      },
      {
        subtitle: 'To improve the service',
        body: `We use aggregated, anonymised analytics to understand which tools are used most, where performance can be improved, and where users experience difficulty. This analysis never involves reading the contents of individual files.`,
      },
      {
        subtitle: 'To communicate with you',
        body: `If you have an account, we may send you:
• Transactional emails (receipts, password resets, billing alerts)
• Service announcements (maintenance windows, feature launches)
• Optional product updates and newsletters only if you opt in

You can unsubscribe from non-transactional emails at any time via the link in any email or from your account settings.`,
      },
      {
        subtitle: 'Monetisation how we make money',
        body: `QuickPDFs is free to use because we offer paid Pro ($7.99/mo) and Business ($19.99/mo) plans for power users and teams who need unlimited processing, larger file sizes, batch operations, and API access.

We do not monetise through advertising, selling user data, or analytics reselling. Our business model is straightforward: subscription revenue from users who find enough value to pay for more.

The Free plan is permanently free and will remain so. We believe access to basic PDF tools should not require payment or data exploitation.`,
      },
    ],
  },
  {
    id: 'sharing',
    icon: Icons.Globe,
    title: '3. Sharing Your Information',
    color: '#F59E0B',
    content: [
      {
        subtitle: 'We do not sell your data',
        body: `QuickPDFs and D-Tech Studios do not sell, rent, lease, or otherwise transfer your personal information to third parties for their own commercial purposes.`,
      },
      {
        subtitle: 'Service providers we use',
        body: `We share limited data with trusted service providers who help us operate QuickPDFs:

• Stripe payment processing (card data, billing history)
• AWS / Cloudflare cloud infrastructure and CDN (file data, in transit only, encrypted)
• PostHog / Plausible privacy-focused analytics (anonymised usage data only)
• Resend / SendGrid transactional email delivery (your email address)

Each provider is contractually bound to use your data only to provide the service we've engaged them for, and not for any other purpose.`,
      },
      {
        subtitle: 'Legal requirements',
        body: `We may disclose your information if required to do so by law, court order, or government regulation, or if we believe disclosure is necessary to protect the rights, property, or safety of QuickPDFs, our users, or the public. We will notify you of such requests where legally permitted to do so.`,
      },
      {
        subtitle: 'Business transfers',
        body: `In the event of a merger, acquisition, or sale of D-Tech Studios or its assets, your information may be transferred as part of that transaction. We will notify you by email and/or prominent notice on our website at least 30 days before any such transfer occurs, and you will have the right to delete your account at that time.`,
      },
    ],
  },
  {
    id: 'filesecurity',
    icon: Icons.Lock,
    title: '4. File Security & Retention',
    color: '#EF4444',
    content: [
      {
        subtitle: 'How your files are protected',
        body: `All file transfers between your browser and our servers are encrypted using TLS 1.3. Files stored temporarily during processing are encrypted at rest using AES-256. Access to processing infrastructure is restricted to automated systems only no employee has routine access to uploaded file contents.`,
      },
      {
        subtitle: 'Automatic deletion',
        body: `This is non-negotiable: every file you upload is automatically and permanently deleted within 1 hour of processing. This applies to:

• The original uploaded file
• The processed output file
• Any temporary intermediate files created during processing

We do not offer a "cloud storage" feature, and we do not retain your files beyond this window under any circumstances.`,
      },
      {
        subtitle: 'File history on paid plans',
        body: `Pro and Business plan subscribers have access to a File History feature in their dashboard. This stores metadata only the filename, tool used, file size, and date for 30 days (Pro) or 90 days (Business). The actual file contents are still deleted within 1 hour as above. You can clear your file history at any time from your account settings.`,
      },
      {
        subtitle: 'Account data retention',
        body: `If you delete your account, all associated personal data (name, email, billing history, file metadata) is permanently deleted within 30 days. We may retain anonymised, aggregate usage statistics that cannot be linked to any individual.`,
      },
    ],
  },
  {
    id: 'cookies',
    icon: Icons.Cookie,
    title: '5. Cookies & Tracking',
    color: '#8B5CF6',
    content: [
      {
        subtitle: 'Cookies we use',
        body: `We use a small number of cookies:

Essential cookies (cannot be disabled):
• Session authentication cookie keeps you logged in to your account
• CSRF protection token prevents cross-site request forgery attacks
• User preference cookie stores your settings (e.g. dark/light mode)

Analytics cookies (can be opted out):
• We use privacy-focused analytics (Plausible) which does not use cookies by default and does not collect personal identifiers. If you have opted into enhanced analytics, a single first-party cookie is set.

We do not use advertising cookies, third-party tracking pixels, or social media tracking buttons.`,
      },
      {
        subtitle: 'Managing cookies',
        body: `You can control cookies through your browser settings. Disabling essential cookies will prevent account login from working. Analytics cookies can be disabled without affecting functionality. You can also opt out of analytics entirely from your account settings.`,
      },
    ],
  },
  {
    id: 'rights',
    icon: Icons.Users,
    title: '6. Your Rights',
    color: '#10B981',
    content: [
      {
        subtitle: 'Rights for all users',
        body: `Regardless of where you are located, you have the right to:

• Know what personal data we hold about you
• Request a copy of your data (data portability)
• Correct inaccurate data
• Delete your account and all associated data
• Withdraw consent for optional processing (e.g. marketing emails)

To exercise any of these rights, email us at privacy@quickpdfs.net or use the controls in your account settings.`,
      },
      {
        subtitle: 'EU/EEA users GDPR rights',
        body: `If you are located in the European Union or European Economic Area, you have additional rights under the General Data Protection Regulation (GDPR):

• Right to object to processing based on legitimate interests
• Right to restriction of processing
• Right to lodge a complaint with your local data protection authority

Our legal basis for processing is: contract performance (for paid subscribers), legitimate interests (for security and analytics), and consent (for marketing communications).

D-Tech Studios processes EU user data under Standard Contractual Clauses where data is transferred outside the EEA.`,
      },
      {
        subtitle: 'California users CCPA rights',
        body: `If you are a California resident, you have rights under the California Consumer Privacy Act (CCPA):

• Right to know what personal information we collect and how it is used
• Right to delete your personal information
• Right to opt out of the "sale" of personal information (we do not sell personal information)
• Right to non-discrimination for exercising your rights

To submit a CCPA request, contact us at privacy@quickpdfs.net with the subject line "CCPA Request".`,
      },
    ],
  },
  {
    id: 'children',
    icon: Icons.Child,
    title: '7. Children\'s Privacy',
    color: '#F59E0B',
    content: [
      {
        subtitle: 'Age restrictions',
        body: `QuickPDFs is not directed to children under the age of 13 (or 16 in the EU). We do not knowingly collect personal information from children under these ages.

If you are a parent or guardian and believe your child has provided us with personal information without your consent, please contact us at privacy@quickpdfs.net and we will delete that information promptly.

Users aged 13–17 may use the Free plan with parental consent. Paid subscriptions require users to be 18 or older, or have explicit parental/guardian consent.`,
      },
    ],
  },
  {
    id: 'changes',
    icon: Icons.Update,
    title: '8. Changes to This Policy',
    color: '#3B82F6',
    content: [
      {
        subtitle: 'How we notify you',
        body: `We may update this Privacy Policy from time to time to reflect changes in our practices, the law, or new features. When we make material changes, we will:

• Update the "Last updated" date at the top of this page
• Send an email notification to all registered account holders at least 14 days before the changes take effect
• Display a prominent notice on the QuickPDFs website

For minor, non-material changes (such as clarifying language or fixing typos), we will update the policy without prior notice beyond updating the date.

Your continued use of QuickPDFs after the effective date of any changes constitutes your acceptance of those changes.`,
      },
    ],
  },
  {
    id: 'contact',
    icon: Icons.Mail,
    title: '9. Contact Us',
    color: '#EF4444',
    content: [
      {
        subtitle: 'Privacy questions and requests',
        body: `If you have any questions about this Privacy Policy, want to exercise your data rights, or have a privacy concern, please contact us:

Email: privacy@quickpdfs.net
General support: support@quickpdfs.net
Company: D-Tech Studios
Product: QuickPDFs.net

We aim to respond to all privacy-related enquiries within 5 business days. For formal data subject requests (e.g. data deletion, data export), we will respond within 30 days as required by applicable law.`,
      },
    ],
  },
];

// ─── Component ────────────────────────────────────────────────────────────────
export default function PrivacyPolicy() {
  const navigate = useNavigate();
  const [activeSection, setActiveSection] = useState('overview');
  const [showBackToTop, setShowBackToTop] = useState(false);
  const sectionRefs = useRef({});

  // Show back-to-top after scroll
  useEffect(() => {
    const handler = () => setShowBackToTop(window.scrollY > 400);
    window.addEventListener('scroll', handler);
    return () => window.removeEventListener('scroll', handler);
  }, []);

  // Track active section on scroll
  useEffect(() => {
    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) setActiveSection(entry.target.id);
        });
      },
      { rootMargin: '-20% 0px -70% 0px' }
    );
    Object.values(sectionRefs.current).forEach(ref => { if (ref) observer.observe(ref); });
    return () => observer.disconnect();
  }, []);

  const scrollToSection = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  const LAST_UPDATED  = 'March 18, 2026';
  const EFFECTIVE     = 'March 18, 2026';

  return (
    <div className="pp-page">

      {/* ── Hero ──────────────────────────────────────────── */}
      <section className="pp-hero">
        <div className="pp-hero-bg" aria-hidden="true" />
        <div className="pp-container">
          <div className="pp-hero-badge">
            <span className="pp-badge-dot" />
            D-Tech Studios · QuickPDFs.net
          </div>
          <h1 className="pp-hero-title">Privacy Policy</h1>
          <p className="pp-hero-sub">
            We built QuickPDFs on a simple promise: your files are yours, processed fast, deleted immediately.
            This policy explains exactly what we collect, how we use it, and why.
          </p>
          <div className="pp-hero-meta">
            <span className="pp-meta-item">
              <Icons.Update /> Last updated: <strong>{LAST_UPDATED}</strong>
            </span>
            <span className="pp-meta-sep">·</span>
            <span className="pp-meta-item">
              Effective: <strong>{EFFECTIVE}</strong>
            </span>
          </div>

          {/* Quick assurances */}
          <div className="pp-assurances">
            {[
              { icon: Icons.Trash,  text: 'Files deleted within 1 hour' },
              { icon: Icons.Eye,    text: 'We never read your files'     },
              { icon: Icons.Dollar, text: 'We never sell your data'      },
              { icon: Icons.Lock,   text: 'AES-256 encryption in transit'},
            ].map((a, i) => (
              <div key={i} className="pp-assurance">
                <span className="pp-assurance-icon"><a.icon /></span>
                {a.text}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── Body: TOC sidebar + content ───────────────────── */}
      <div className="pp-body">
        <div className="pp-container pp-body-inner">

          {/* Sticky table of contents */}
          <aside className="pp-toc">
            <p className="pp-toc-label">Table of contents</p>
            <nav className="pp-toc-nav">
              {SECTIONS.map(s => (
                <button
                  key={s.id}
                  className={`pp-toc-item${activeSection === s.id ? ' active' : ''}`}
                  style={{ '--tc': s.color }}
                  onClick={() => scrollToSection(s.id)}
                >
                  <span className="pp-toc-dot" style={{ background: s.color }} />
                  {s.title}
                  <Icons.ChevronRight className="pp-toc-arrow" />
                </button>
              ))}
            </nav>
            <div className="pp-toc-footer">
              <button className="pp-toc-contact" onClick={() => navigate('/Contact')}>
                <Icons.Mail /> Questions? Contact us
              </button>
            </div>
          </aside>

          {/* Content */}
          <main className="pp-content">
            {SECTIONS.map(section => (
              <section
                key={section.id}
                id={section.id}
                ref={el => (sectionRefs.current[section.id] = el)}
                className="pp-section"
              >
                {/* Section header */}
                <div className="pp-section-head">
                  <span className="pp-section-icon" style={{ background: `${section.color}14`, color: section.color }}>
                    <section.icon />
                  </span>
                  <h2 className="pp-section-title" style={{ '--hc': section.color }}>
                    {section.title}
                  </h2>
                </div>

                {/* Summary card layout (overview section) */}
                {section.summary && (
                  <div className="pp-summary-grid">
                    {section.cards.map((card, i) => (
                      <div key={i} className="pp-summary-card" style={{ '--cc': card.color }}>
                        <span className="pp-summary-icon" style={{ background: `${card.color}14`, color: card.color }}>
                          <card.icon />
                        </span>
                        <h3 className="pp-summary-title">{card.title}</h3>
                        <p className="pp-summary-body">{card.body}</p>
                      </div>
                    ))}
                  </div>
                )}

                {/* Regular prose layout */}
                {!section.summary && section.content.map((block, i) => (
                  <div key={i} className="pp-block">
                    <h3 className="pp-block-title">{block.subtitle}</h3>
                    <div className="pp-block-body">
                      {block.body.split('\n\n').map((para, j) => (
                        <p key={j} className={para.startsWith('•') || para.includes('\n•') ? 'pp-para pp-para--list' : 'pp-para'}>
                          {para.split('\n').map((line, k) => (
                            <span key={k}>
                              {line}
                              {k < para.split('\n').length - 1 && <br />}
                            </span>
                          ))}
                        </p>
                      ))}
                    </div>
                  </div>
                ))}
              </section>
            ))}

            {/* Final note */}
            <div className="pp-final-note">
              <Icons.Shield className="pp-final-icon" />
              <div>
                <p className="pp-final-title">Questions about this policy?</p>
                <p className="pp-final-body">
                  We're happy to explain anything in plain language.
                  Email us at <a href="mailto:privacy@quickpdfs.net">privacy@quickpdfs.net</a> or{' '}
                  <button className="pp-inline-link" onClick={() => navigate('/Contact')}>use our contact form</button>.
                </p>
              </div>
            </div>
          </main>
        </div>
      </div>

      {/* ── Back to top ───────────────────────────────────── */}
      {showBackToTop && (
        <button
          className="pp-back-to-top"
          onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
          aria-label="Back to top"
        >
          <Icons.ArrowUp />
        </button>
      )}
    </div>
  );
}